import React, { PropTypes } from 'react';

class ListItemForTaskInput extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    // EVENT HANDLERS

    handleMouseDown = (mouseEvent) => {
        if (mouseEvent.button === 0) {
            this.props.mouseDown(this.props.index);
        }
    }

    handleMouseOver = () => { this.props.mouseOver(this.props.index); }

    // RENDER METHOD

    render = () => {
        if (this.props.oneline) {
            return (
                <li
                    style={{paddingTop: "3px", paddingBottom: "3px"}}
                    key={this.props.id}
                    id={this.props.id}
                    className={this.props.classNames}
                    onMouseDown={this.handleMouseDown}
                    onMouseOver={this.handleMouseOver}
                    title={this.props.taskName.length > 50 ? this.props.taskName : null}>
                        {this.props.taskName}
                </li>
            );
        } else {
            return (
                <li
                    key={this.props.id}
                    id={this.props.id}
                    style={{"paddingTop": "3px", "paddingBottom": "3px", "border" : "0px", "margin" : "0px"}}
                    className={this.props.classNames}
                    onMouseDown={this.handleMouseDown}
                    onMouseOver={this.handleMouseOver}
                    title={this.props.taskName.length > 50 ? this.props.taskName : null}>
                        {this.props.projectName ? this.props.projectName : "Floating task"}<br/>
                        {this.props.taskName}
                </li>
            );
        }
    }
}

ListItemForTaskInput.propTypes = {
    classNames: PropTypes.string,
    id: PropTypes.number,
    index: PropTypes.number,
    mouseDown: PropTypes.func,
    mouseOver: PropTypes.func,
    oneline: PropTypes.bool,
    projectName: PropTypes.string, //TODO renamed from "project" to "projectName", rename prop in all parent components
    taskName: PropTypes.string //TODO renamed from "task" to "taskName", rename prop in all parent components
};

export default ListItemForTaskInput;



/** WEBPACK FOOTER **
 ** ./src/app/components/ListItemForTaskInput.js
 **/